import React from 'react';

const GlobalStatesContext = React.createContext();

export default GlobalStatesContext;